// extracted by mini-css-extract-plugin
export var lg = "_1c-4";
export var md = "_1c-3";
export var sm = "_1c-2";
export var xs = "_1c-1";
export var xxs = "_1c-0";